module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABSUlEQVRoQ+2YMQ6CQBBFZ/ESajyBVkpBJ8ZGb+MRxAt4HxujVlKgnScwxEvIGgqSJREzw2YCi2M9+2f+f7C4q8Dxn3J8fhADTRP8HwKz83CrNERaQXQL0x1H8nV6oAn4p6Euhk4WKXodxWidHuhB6ohThs9r6/TonoHppT/2tLcHDStqgqz1Ssfw7m2S5TM2+5QI+MdRAF52ZR3EUjzzssl9/noUMmUD58EVtAose/AuV3BIwnT93YCx0/BOYadu7oJlAmLALlns6koCWIE21aG/A20aunIbbeuQv+aSl7gJarKNNpG62ZNEgHKAKQ4k3AZJBqiHF/M/PZcRkgHnCXClaKNLImDTiGutGOBKFqsrBLBJcdUJAa5ksbpCAJsUV50Q4EoWq9thAs5fLbp+uZs/g05fr2NfojbVyc1c0zSEgBCwTMD5R+gDuczEMbSqcYUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./img/historyicon.png
// module id = lXH9
// module chunks = 1